module.exports = __webpack_public_path__ + "img/background-pos-detail.c418501d.svg";